module.exports = __webpack_public_path__ + "img/Earth_Potion.f4b8ba0c.png";